import i18n from 'i18n';

/**
 * Direct resource lookup for accounting namespace.
 * Bypasses i18next's separator parsing to reliably access flat keys with colons.
 */
export function getAccountingTranslation(
  flatKey: string,
  defaultValue: string = flatKey
): string {
  try {
    const currentLang = i18n.language || 'en';
    const resources = i18n.getResourceBundle(currentLang, 'accounting');

    if (resources && flatKey in resources) {
      return resources[flatKey] as string;
    }
  } catch (err) {
    // Silently fall back if lookup fails
  }

  return defaultValue;
}
